import { withStyles, Select } from '@material-ui/core';

export const StyledSelect = withStyles({
  root: {
    backgroundColor: 'transparent',
    border: 0,
    width: '100%',
    padding: 0,
  },
  // @ts-expect-error - Material-UI v4 styled component type conflict with React 18
})(Select);
